import { render } from "./UserDetailTemplate.vue?vue&type=template&id=5cc67d0f"
import script from "./UserDetailTemplate.vue?vue&type=script&lang=js"
export * from "./UserDetailTemplate.vue?vue&type=script&lang=js"

import "./UserDetailTemplate.vue?vue&type=style&index=0&id=5cc67d0f&lang=css"

import exportComponent from "/var/www/html2/esmanage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__